import { Component } from '@angular/core';
import {BreadcrumbHeaderComponent} from '../../../LandingPage/NavigationMenu/page-headline/page-headline.component';
import {
  TwoSplitImageBulletPointsSectionComponent
} from '../two-split-image-bullet-points-section/two-split-image-bullet-points-section.component';
import {TwoSplitLegalSectionComponent} from '../two-split-legal-section/two-split-legal-section.component';
import {ColorScssService} from '../../../shared/service/color-scss.service';

@Component({
  selector: 'app-rechtliches',
  standalone: true,
  imports: [
    BreadcrumbHeaderComponent,
    TwoSplitImageBulletPointsSectionComponent,
    TwoSplitLegalSectionComponent
  ],
  templateUrl: './rechtliches.component.html',
  styleUrl: './rechtliches.component.scss'
})
export class RechtlichesComponent {
  constructor(private color:ColorScssService) {
    this.color.resetColorScheme()
  }
}
